import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { userRolesGetThunk } from "./thunk";

import { RootState } from "slices/store";
import { UserRole } from 'models/user/user-role'
import { APIResult } from "models/api-results";
import { BrandingData } from "admin-portal/settings/branding";

export interface CoreDataState {
    userRoles: UserRole[],

}

export const initialState: CoreDataState = {
    userRoles: []
};

const coreDataSlice = createSlice({
    name: "core-data",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {

        builder.addCase(userRolesGetThunk.fulfilled, (state: CoreDataState, action: any) => {
            if (action.payload) {
                const _apiData: APIResult<UserRole[]> = action.payload;

                if ((action.payload?.status?.isError ?? false)) {

                } else {
                    let _data = _apiData.data ?? [];
                    _data.forEach((item) => {
                        item.dbKey = item.name;
                        item.name = (item.name ?? "").toLocaleLowerCase().replaceAll("tenant", BrandingData.bussinessDomain).toUpperCase()
                    })
                    _data = _data.sort((a, b) => a.name! < b.name! ? -1 : ((a.name! > b.name!) ? 1 : 0))
                    state.userRoles = _data;
                }
            } else {

            }

        });
    }
});

export const { } = coreDataSlice.actions;
export default coreDataSlice.reducer;
export const getCoreDataState = (store: RootState): CoreDataState => store.coredata;
